import { cn } from "@/lib/utils";

// Card container padrão (superfície escura + borda sutil).
export const Panel = ({ title, action, children, className, bodyClassName, noPadding = false, icon: Icon }) => (
  <section className={cn("rounded-xl border border-line bg-surface card-grad", className)}>
    {(title || action) && (
      <header className="flex items-center justify-between gap-3 border-b border-line px-4 py-3 sm:px-5">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
          <h2 className="font-heading text-base font-semibold text-foreground">{title}</h2>
        </div>
        {action}
      </header>
    )}
    <div className={cn(!noPadding && "p-4 sm:p-5", bodyClassName)}>{children}</div>
  </section>
);
